export default __webpack_public_path__ + "345c76f40e98237a1c56bca3ea9c7e0b.png";